<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark"> Nova Mesa </span>
      </h3>
    </div>
    <Form url="/restaurante/mesas/create" :mesa="mesa" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Form from "./Form.vue";
import MesaData from "./MesaData";

export default {
  name: "app-restaurante-mesas-create",
  data() {
    return {
      mesa: new MesaData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
